import styled from 'styled-components';
import device from '#app/interface/devices';

// Импорты изображений
import swanImg from './images/swan-b.svg';
import checkImg from './images/icon-check.svg';
import waveImg from './images/welcome-wave-w.png';
import blackImg from './images/black-back.svg';

// Общие стили для кнопок
const buttonStyles = `
  color: #fff;
  background: #4378FF;
  display: inline-block;
  cursor: pointer;
  font-size: 18px;
  line-height: 32px;
  padding: 8px 18px;
  white-space: nowrap;
  height: 48px;
  border-radius: 10px;
  border: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  transition: .3s all;
  box-sizing: border-box;
  text-decoration: none;

  &:hover {
    background: #2c5ce6;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media ${device.mobileM} {
    font-size: 16px;
    padding: 6px 14px;
    height: 40px;
    line-height: 28px;
  }
`;

export const Container = styled.div`
  min-height: 100vh;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 28px;
  font-family:
    'Noto Sans',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  font-variant-numeric: proportional-nums;

  @media ${device.mobileM} {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const Wrap = styled.div`
  max-width: 1440px;
  padding: 0 50px;
  margin: 0 auto;
  position: relative;

  @media ${device.laptopM} {
    padding: 0 30px;
  }

  @media ${device.tablet} {
    padding: 0 20px;
  }

  @media ${device.mobileM} {
    padding: 0 16px;
  }
`;

export const WelcomeBlock = styled.div`
  padding: 0;
  background-color: #fff;
`;

export const WelcomeTitle = styled.div`
  background: no-repeat center top url(${swanImg});
  text-align: center;
  max-width: 880px;
  padding: 77px 0 0;
  margin: 0 auto 23px;

  p {
    margin-bottom: 0;
  }

  h1 {
    margin: 0 0 40px;
    font-size: 50px;
    line-height: 62px;
    letter-spacing: -0.02em;

    @media ${device.laptopM} {
      font-size: 42px;
      line-height: 52px;
    }

    @media ${device.tablet} {
      font-size: 36px;
      line-height: 44px;
      margin: 0 0 30px;
    }

    @media ${device.mobileM} {
      font-size: 28px;
      line-height: 36px;
      margin: 0 0 20px;
    }
  }

  p a {
    line-height: 28px;
    ${buttonStyles}
  }

  @media ${device.tablet} {
    padding: 60px 0 0;
    background-size: 60px;
  }

  @media ${device.mobileM} {
    padding: 40px 0 0;
    background-size: 50px;
  }
`;

export const WelcomeScreen = styled.div`
  display: flex;
  margin: 80px 0 57px;
  position: relative;
  z-index: 5;
  gap: 4.5%;

  @media ${device.laptopM} {
    margin: 60px 0 40px;
  }

  @media ${device.tablet} {
    flex-direction: column;
    margin: 40px 0 30px;
    gap: 20px;
    align-items: center;
  }

  @media ${device.mobileM} {
    margin: 30px 0 20px;
  }
`;

export const WelcomeIphone = styled.div`
  width: 22%;
  transform: rotate(0);
  transition: 1s transform;
  display: flex;
  align-content: center;
  line-height: 0;

  img,
  svg {
    filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.1));
    width: 100%;
    height: auto;
  }

  @media ${device.tablet} {
    width: 40%;
    max-width: 200px;
  }

  @media ${device.mobileM} {
    width: 50%;
    max-width: 150px;
  }
`;

export const WelcomeWeb = styled.div`
  width: 73.5%;
  display: flex;
  align-content: center;
  line-height: 0;

  img,
  svg {
    filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.1));
    width: 100%;
    height: auto;
  }

  @media ${device.tablet} {
    width: 90%;
    max-width: 600px;
  }

  @media ${device.mobileM} {
    width: 100%;
  }
`;

export const WelcomeFunction = styled.div`
  background: #f3f3f3;
  position: relative;
  z-index: 1;
  padding: 80px 0 72px;

  h2 {
    font-weight: 600;
    font-size: 32px;
    line-height: 44px;
    letter-spacing: -0.02em;
    text-align: center;
    margin: 20px 105px 20px 0;

    @media ${device.laptopM} {
      margin: 20px 0;
      font-size: 28px;
      line-height: 38px;
    }

    @media ${device.tablet} {
      font-size: 24px;
      line-height: 32px;
    }

    @media ${device.mobileM} {
      font-size: 20px;
      line-height: 28px;
    }
  }

  &:before {
    height: 340px;
    left: 0;
    right: 0;
    top: -340px;
    display: block;
    position: absolute;
    content: '';
    background: no-repeat center center;
    background-size: 100% 340px;
    background-image: url(${waveImg});

    @media ${device.tablet} {
      height: 200px;
      top: -200px;
      background-size: 100% 200px;
      background-image: none;
    }

    @media ${device.mobileM} {
      height: 100px;
      top: -100px;
      background-size: 100% 100px;
      background-image: none;
    }
  }

  @media ${device.laptopM} {
    padding: 60px 0 50px;
  }

  @media ${device.tablet} {
    padding: 40px 0 30px;
  }
`;

export const Functions = styled.div`
  margin: 40px 0 0;
  color: #000;
  display: flex;
  justify-content: center;
  gap: 6%;

  & > div {
    width: 27%;

    @media ${device.laptopM} {
      width: 45%;
    }

    @media ${device.tablet} {
      width: 100%;
    }
  }

  & > div > div {
    width: 100%;
    padding-left: 47px;
    padding-right: 10%;
    vertical-align: top;
    margin: 18px 0;
    display: inline-block;
    position: relative;
    min-height: 48px;

    &:before {
      background-image: url(${checkImg});
      width: 27px;
      height: 24px;
      top: 2px;
      position: absolute;
      left: 0;
      content: '';
      display: block;
    }

    @media ${device.tablet} {
      padding-right: 0;
    }

    @media ${device.mobileM} {
      padding-left: 35px;
      font-size: 14px;
      margin: 15px 0;

      &:before {
        width: 20px;
        height: 18px;
        background-size: contain;
      }
    }
  }

  @media ${device.laptopM} {
    flex-direction: column;
    align-items: center;

    & > div {
      margin-left: 0;
    }
  }

  @media ${device.tablet} {
    margin: 30px 0 0;
  }
`;

export const TryNow = styled.div`
  height: 230px;
  text-align: center;

  & > div > form {
    display: inline-block;
    width: 100%;
    max-width: 600px;

    @media ${device.tablet} {
      max-width: 100%;
    }
  }

  & > div > form > div {
    margin: 10px 0;
    display: flex;

    @media ${device.mobileM} {
      flex-direction: column;
      gap: 10px;
    }
  }

  & > div > form > div:last-child {
    margin-bottom: 0;
  }

  & > div > form > div:first-child {
    margin-top: 0;
  }

  & > div > form > div > .input {
    width: 100%;
    margin-right: 16px;

    @media ${device.mobileM} {
      margin-right: 0;
    }
  }

  & > div > form > div > .input > input {
    background: rgba(0, 0, 0, 0.05);
    color: #000;
    border-radius: 10px;
    padding: 8px 18px;
    font-size: 18px;
    line-height: 32px;
    height: 48px;
    border: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    transition: 0.3s all;
    width: 100%;

    @media ${device.mobileM} {
      font-size: 16px;
      height: 40px;
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px #4378ff;
    }
  }

  & > div > form > div > .submit {
    width: 150px;

    @media ${device.mobileM} {
      width: 100%;
    }
  }

  & > div > form > div > .submit > button {
    width: 100%;
    ${buttonStyles}
  }

  @media ${device.tablet} {
    height: auto;
    padding: 40px 0;
  }

  @media ${device.mobileM} {
    padding: 30px 0;
  }
`;

export const Blocks = styled.div`
  background-color: #fff;

  :after {
    display: block;
    clear: both;
    content: '';
  }
`;

export const BlockText = styled.div`
  width: 50%;
  margin: 30px 0;

  h2 {
    font-size: 32px;
    line-height: 44px;
    margin: 20px 0;

    @media ${device.laptopM} {
      font-size: 28px;
      line-height: 38px;
    }

    @media ${device.tablet} {
      font-size: 24px;
      line-height: 32px;
    }

    @media ${device.mobileM} {
      font-size: 20px;
      line-height: 28px;
    }
  }

  p {
    margin: 15px 0;

    @media ${device.mobileM} {
      font-size: 16px;
      line-height: 24px;
    }
  }

  @media ${device.laptopL} {
    width: 100%;
    margin: 20px 0;
  }

  @media ${device.tablet} {
    text-align: center;
  }
`;

export const BlockPic = styled.div`
  width: 50%;
  margin: 30px 0;

  img,
  svg {
    width: 100%;
    height: auto;
    object-fit: contain;
  }

  & > .block-pic-1 {
    display: flex;
    justify-content: center;
    align-items: center;

    img,
    svg {
      max-width: 100%;
    }
  }

  & > .block-pic-2 {
    width: 100%;
    max-width: 340px;
    height: 450px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: space-between;
    align-items: center;
    margin: 0 auto;
    margin-top: 50px;

    & > div {
      width: calc(50% - 10px);
      max-width: 160px;
      margin: 5px;
      display: inline-block;
      line-height: 0;
      border-radius: 10px;
      overflow: hidden;
      box-shadow: 0 0 20px rgba(32, 32, 32, 0.1);
    }

    @media ${device.tablet} {
      height: auto;
      flex-direction: row;
      justify-content: center;
      flex-wrap: wrap;
      gap: 10px;

      & > div {
        width: 140px;

        :first-child {
          margin-top: 5px;
        }
      }
    }

    @media ${device.mobileM} {
      & > div {
        width: 120px;
      }
    }
  }

  & > .block-pic-3 {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;

    & > div {
      max-width: 176px;
      margin: 5px;
      display: inline-block;
      line-height: 0;
      border-radius: 10px;
      overflow: hidden;
      box-shadow: 0 0 20px rgba(32, 32, 32, 0.1);

      @media ${device.tablet} {
        max-width: 140px;
      }

      @media ${device.mobileM} {
        max-width: 120px;
      }
    }
  }

  & > .block-pic-4 {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    & > div {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    }

    svg {
      max-width: 100%;
      height: auto;
    }

    @media ${device.mobileM} {
      gap: 6px;
    }
  }

  @media ${device.laptopL} {
    display: none;
  }
`;

export const BlockOdd = styled.div`
  max-width: 1440px;
  padding: 0 20px;
  margin: 0 auto;
  position: relative;

  & > div {
    display: flex;
    min-height: 342px;
    align-items: center;
    gap: 50px;
  }

  @media ${device.laptopL} {
    & > div {
      min-height: 242px;
      flex-direction: column;
      text-align: center;
      gap: 20px;
    }
  }

  @media ${device.laptopM} {
    padding: 0 30px;
  }

  @media ${device.tablet} {
    padding: 0 20px;
  }

  @media ${device.mobileM} {
    padding: 0 16px;
  }
`;

export const BlockEven = styled.div`
  max-width: 1440px;
  padding: 0 20px;
  margin: 0 auto;
  position: relative;

  & > div {
    display: flex;
    min-height: 372px;
    align-items: center;
    gap: 50px;
  }

  & > div:last-child {
    margin-bottom: 30px;
  }

  @media ${device.laptopL} {
    & > div {
      min-height: 242px;
      flex-direction: column-reverse;
      text-align: center;
      gap: 20px;
    }
  }

  @media ${device.laptopM} {
    padding: 0 30px;
  }

  @media ${device.tablet} {
    padding: 0 20px;
  }

  @media ${device.mobileM} {
    padding: 0 16px;
  }
`;

export const RoboBlock = styled.div`
  padding: 80px 0;
  background: #f3f3f3;
  text-align: center;

  @media ${device.laptopM} {
    padding: 60px 0;
  }

  @media ${device.tablet} {
    padding: 50px 0;
  }

  @media ${device.mobileM} {
    padding: 40px 0;
  }
`;

export const RoboBlockContent = styled.div`
  max-width: 900px;
  margin: 0 auto;
  text-align: center;

  & > div:first-child {
    opacity: 1 !important;
    transform: none !important;
    transition: none !important;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    img {
      width: 60px;
      height: 60px;
      object-fit: contain;
      display: block;
    }

    @media ${device.mobileM} {
      margin-bottom: 16px;

      img {
        width: 50px;
        height: 50px;
      }
    }
  }

  h2 {
    font-size: 32px;
    line-height: 44px;
    margin: 20px 0;
    color: #202020;
    font-weight: 600;

    @media ${device.laptopM} {
      font-size: 28px;
      line-height: 38px;
    }

    @media ${device.tablet} {
      font-size: 24px;
      line-height: 32px;
    }

    @media ${device.mobileM} {
      font-size: 20px;
      line-height: 28px;
    }
  }

  p {
    font-size: 18px;
    line-height: 28px;
    color: #666;
    margin: 20px 0;

    @media ${device.mobileM} {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const BlackSwanLogoWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 0 20px 0;
`;

export const BlackSwan = styled.div`
  padding: 100px 0;
  background: #202020 no-repeat center center url(${blackImg});
  background-size: cover;
  color: #fff;
  text-align: center;

  h1,
  h2 {
    color: #fff;
    text-align: center;
    margin: 20px 0;

    @media ${device.tablet} {
      font-size: 24px;
      line-height: 32px;
    }

    @media ${device.mobileM} {
      font-size: 20px;
      line-height: 28px;
    }
  }

  p {
    margin: 20px 0;

    @media ${device.mobileM} {
      font-size: 16px;
      line-height: 24px;
    }
  }

  p.link {
    margin-top: 40px;
    height: 40px;
    line-height: 0;

    @media ${device.mobileM} {
      margin-top: 30px;
    }
  }

  p a {
    ${buttonStyles}
  }

  @media ${device.laptopM} {
    padding: 80px 0;
  }

  @media ${device.tablet} {
    padding: 60px 0;
  }

  @media ${device.mobileM} {
    padding: 40px 0;
  }
`;

export const Footer = styled.div`
  min-height: 230px;
  background: #f3f3f3;
  padding: 32px 0 24px;

  & > div {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    @media ${device.tablet} {
      flex-direction: column;
      gap: 20px;
    }
  }

  & > div:first-child {
    margin-bottom: 20px;

    @media ${device.tablet} {
      margin-bottom: 10px;
    }
  }

  a {
    color: rgba(32, 32, 32, 1);
    transition: color 0.3s ease;

    &:hover {
      color: rgba(32, 32, 32, 0.6);
    }
  }

  @media ${device.laptopM} {
    padding: 24px 0 18px;
  }

  @media ${device.mobileM} {
    padding: 20px 0 16px;
    min-height: auto;
  }
`;

export const FooterLeft = styled.div`
  @media ${device.laptop} {
    margin-top: 28px;
  }

  @media ${device.tablet} {
    margin-top: 0px;
  }

  div.footer-copyright {
    font-size: 14px;
    line-height: 24px;
    display: block;
    margin-top: 10px;

    a {
      color: #929292;
      font-size: 14px;
      line-height: 16px;
      border-bottom: solid 1px rgba(0, 0, 0, 0.1);
      margin-right: 16px;
      text-decoration: none;

      &:hover {
        color: rgba(0, 0, 0, 1);
        border-bottom: solid 1px rgba(0, 0, 0, 0.2);
      }

      @media ${device.mobileM} {
        margin-right: 10px;
        font-size: 13px;
      }
    }
  }
`;

export const FooterRight = styled.div`
  white-space: nowrap;

  div.footer-phone,
  div.footer-email {
    display: inline-block;
    margin-right: 80px;

    @media ${device.tablet} {
      margin-right: 20px;
      display: block;
      margin-bottom: 10px;
    }

    @media ${device.mobileM} {
      margin-right: 0;
    }
  }

  @media ${device.tablet} {
    white-space: normal;
  }
`;

export const AnimatedBlocks = styled(Blocks)`
  overflow: hidden;
`;

export const AnimatedBlockOdd = styled(BlockOdd)`
  opacity: 0;
  transform: translateY(60px);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const AnimatedBlockEven = styled(BlockEven)`
  opacity: 0;
  transform: translateY(60px);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const RoboButton = styled.a`
  ${buttonStyles}
  margin-top: 24px;
  display: inline-block;

  @media ${device.mobileM} {
    margin-top: 20px;
  }
`;

export const LogoWrapper = styled.div`
  opacity: 0;
  transform: translateY(-20px);
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.2s;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  img {
    width: 60px;
    height: 60px;
    object-fit: contain;
    display: block;
  }

  @media ${device.mobileM} {
    margin-bottom: 16px;

    img {
      width: 50px;
      height: 50px;
    }
  }
`;

export const AnimatedBlockText = styled(BlockText)`
  opacity: 0;
  transform: translateX(${(props) => (props['data-direction'] === 'left' ? '-50px' : '50px')});
  transition: all 0.9s cubic-bezier(0.4, 0, 0.2, 1);

  &.visible {
    opacity: 1;
    transform: translateX(0);
  }

  .subtitle {
    opacity: 0;
    transform: translateY(-20px);
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.2s;
  }

  &.visible .subtitle {
    opacity: 1;
    transform: translateY(0);
  }

  &.visible ${LogoWrapper} {
    opacity: 1;
    transform: translateY(0);
  }

  h2 {
    opacity: 0;
    transform: translateY(20px);
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.3s;
  }

  &.visible h2 {
    opacity: 1;
    transform: translateY(0);
  }

  p {
    opacity: 0;
    transform: translateY(20px);
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.4s;
  }

  &.visible p {
    opacity: 1;
    transform: translateY(0);
  }

  p:nth-child(2) {
    transition-delay: 0.5s;
  }
`;

export const AnimatedBlockPic = styled(BlockPic)`
  opacity: 0;
  transform: translateX(${(props) => (props['data-direction'] === 'left' ? '-50px' : '50px')});
  transition: all 0.9s cubic-bezier(0.4, 0, 0.2, 1) 0.1s;

  &.visible {
    opacity: 1;
    transform: translateX(0);
  }

  & > div > div {
    opacity: 0;
    transform: scale(0.85) translateY(30px);
    transition: all 0.7s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &.visible > div > div {
    opacity: 1;
    transform: scale(1) translateY(0);
  }

  & > .block-pic-2 > div {
    &:nth-child(1) {
      transition-delay: 0.1s;
    }
    &:nth-child(2) {
      transition-delay: 0.25s;
    }
  }

  &.visible > .block-pic-3 > div {
    transform: scale(1) rotate(0deg);
  }

  & > .block-pic-3 > div {
    transform: scale(0.85) rotate(-5deg);
  }

  & > .block-pic-4 > div {
    opacity: 0;
    transform: scale(0.9);

    &:nth-child(1) {
      transform-origin: top left;
      transition-delay: 0.1s;
    }
    &:nth-child(2) {
      transform-origin: top right;
      transition-delay: 0.2s;
    }
    &:nth-child(3) {
      transform-origin: bottom left;
      transition-delay: 0.3s;
    }
    &:nth-child(4) {
      transform-origin: bottom right;
      transition-delay: 0.4s;
    }
  }

  &.visible > .block-pic-4 > div {
    opacity: 1;
    transform: scale(1);
  }
`;

export const AnimatedWelcomeBlock = styled(WelcomeBlock)`
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle at 20% 80%, rgba(67, 120, 255, 0.05) 0%, transparent 50%);
    animation: float 20s ease-in-out infinite;
    pointer-events: none;
  }

  @media ${device.mobileL} {
    min-height: 80vh; //чтобы на мобильном первый экран был на высоту экрана, смотрится лучше
  }
`;

export const ParallaxWelcomeTitle = styled(WelcomeTitle)`
  transition:
    transform 0.1s ease-out,
    opacity 0.1s ease-out;
  will-change: transform, opacity;

  h1 {
    opacity: 0;
    transform: translateY(40px);
    transition: all 1s cubic-bezier(0.16, 1, 0.3, 1);
  }

  p {
    opacity: 0;
    transform: translateY(40px);
    transition: all 1s cubic-bezier(0.16, 1, 0.3, 1) 0.2s;
  }

  p.link {
    opacity: 0;
    transform: translateY(40px);
    transition: all 1s cubic-bezier(0.16, 1, 0.3, 1) 0.4s;

    a {
      position: relative;
      overflow: hidden;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: -100%;
        width: 100%;
        height: 2px;
        background: linear-gradient(90deg, transparent, #4378ff, transparent);
        transition: left 0.5s ease;
      }

      &:hover::after {
        left: 100%;
      }
    }
  }

  &.loaded {
    h1,
    p,
    p.link {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const ParallaxWelcomeScreen = styled(WelcomeScreen)`
  position: relative;
  perspective: 1000px;
`;

export const ParallaxWelcomeIphone = styled(WelcomeIphone)`
  transition: transform 0.1s ease-out;
  will-change: transform;
  opacity: 0;
  transform: translateY(60px) rotate(0deg);
  animation: slideInPhone 1.2s cubic-bezier(0.16, 1, 0.3, 1) 0.6s forwards;

  img,
  svg {
    filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.15));
    transition: filter 0.3s ease;
  }

  &:hover img,
  &:hover svg {
    filter: drop-shadow(0 25px 50px rgba(0, 0, 0, 0.3));
  }

  @keyframes slideInPhone {
    to {
      opacity: 1;
      transform: translateY(0) rotate(0deg);
    }
  }

  @media ${device.mobileL} {
    display: none;
  }
`;

export const ParallaxWelcomeWeb = styled(WelcomeWeb)`
  transition: transform 0.1s ease-out;
  will-change: transform;
  opacity: 0;
  transform: translateY(80px) scale(0.95);
  animation: slideInWeb 1.2s cubic-bezier(0.16, 1, 0.3, 1) 0.8s forwards;

  img,
  svg {
    filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.15));
    transition:
      filter 0.3s ease,
      transform 0.3s ease;
  }

  &:hover img,
  &:hover svg {
    filter: drop-shadow(0 30px 60px rgba(0, 0, 0, 0.25));
    transform: translateY(-5px);
  }

  @keyframes slideInWeb {
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @media ${device.mobileL} {
    display: none;
  }
`;

export const AnimatedWelcomeFunction = styled(WelcomeFunction)`
  position: relative;
  overflow: hidden;

  h2 {
    opacity: 0;
    transform: translateY(30px);
    transition: all 0.8s cubic-bezier(0.16, 1, 0.3, 1);

    &.visible {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const AnimatedFunctions = styled(Functions)`
  & > div:first-child {
    opacity: 0;
    transform: translateX(-80px);
    transition: all 0.9s cubic-bezier(0.16, 1, 0.3, 1);

    &.visible {
      opacity: 1;
      transform: translateX(0);
    }

    & > div {
      opacity: 0;
      transform: translateX(-40px);
      transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);

      &:nth-child(1) {
        transition-delay: 0.2s;
      }
      &:nth-child(2) {
        transition-delay: 0.35s;
      }
      &:nth-child(3) {
        transition-delay: 0.5s;
      }
    }

    &.visible > div {
      opacity: 1;
      transform: translateX(0);
    }
  }

  & > div:last-child {
    opacity: 0;
    transform: translateX(80px);
    transition: all 0.9s cubic-bezier(0.16, 1, 0.3, 1) 0.15s;

    &.visible {
      opacity: 1;
      transform: translateX(0);
    }

    & > div {
      opacity: 0;
      transform: translateX(40px);
      transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);

      &:nth-child(1) {
        transition-delay: 0.3s;
      }
      &:nth-child(2) {
        transition-delay: 0.45s;
      }
      &:nth-child(3) {
        transition-delay: 0.6s;
      }
    }

    &.visible > div {
      opacity: 1;
      transform: translateX(0);
    }
  }

  & > div > div {
    position: relative;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);

    &:hover {
      transform: translateX(10px);
      color: #4378ff;
    }

    &:before {
      transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    }
  }

  @media ${device.laptopM} {
    & > div:first-child,
    & > div:last-child {
      transform: translateY(50px);

      &.visible {
        transform: translateY(0);
      }
    }

    & > div > div {
      &:hover {
        transform: translateY(-5px);
      }
    }
  }
`;
